import { PagePlaceholder } from "../page-placeholder/page-placeholder";

export function Drill(): JSX.Element {
  return <PagePlaceholder title="Drill" />;
}
